import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  name: Yup.string().max(16, 'Maximum length is 16 characters'),
  ArchiveStorageDays: Yup.number(
    'Archive Database Storage Time Limit must be integer',
  ).typeError('Archive Database Storage Time Limit must be integer'),
  DSTOffset: Yup.number(
    'Daylight Savings Time Adjustment must be integer',
  ).typeError('Daylight Savings Time Adjustment must be integer'),
  LocalDatabaseStorageDays: Yup.number(
    'Local Database Storage Time Limit (days) must be integer',
  ).typeError('Local Database Storage Time Limit (days) must be integer'),
  // LoginFailureHours: Yup.number(
  //   'Login Failure Time Span (hours) must be integer',
  // ).typeError('Login Failure Time Span (hours) must be integer'),
  // LoginMaxFailures: Yup.number('Login Fail Limit must be integer').typeError(
  //   'Login Fail Limit must be integer',
  // ),
  // PasswordComplexity: Yup.number('Password Complexity must be integer')
  //   .typeError('Password Complexity must be integer')
  //   .min(0, 'Password Complexity must be between 0-100')
  //   .max(100, 'Password Complexity must be between 0-100'),
  PasswordExpirationDays: Yup.number(
    'Password Expiration (days) must be integer',
  ).typeError('Password Expiration (days) must be integer'),
  PasswordRequiredLength: Yup.number(
    'Password Require Length must be integer',
  ).typeError('Password Require Length must be integer'),
  PasswordHistoryThreshold: Yup.number(
    'Password History Retention must be integer',
  )
    .max(100, 'Password History Retention limit is 100')
    .typeError('Password History Retention must be integer'),
  PasswordRequiredUniqueChars: Yup.number(
    'Password Require Unique Characters must be integer',
  ).typeError('Password Require Unique Characters must be integer'),
  // PasswordExpireWarningDays: Yup.number(
  //   'Password Expire Warning (days) must be integer',
  // ).typeError('Password Expire Warning (days) must be integer'),
  ValueRefreshRateSec: Yup.number(
    'Values Refresh Rate (sec) must be integer',
  ).typeError('Values Refresh Rate (sec) must be integer'),
  RemoteCommLossTimeout: Yup.number(
    'Remotes Comm. Loss Timeout (min) must be integer',
  ).typeError('Remotes Comm. Loss Timeout (min) must be integer'),
  SessionTimeoutMinutes: Yup.number(
    'Session Timeout (min) must be integer',
  ).typeError('Session Timeout (min) must be integer'),
  TimeZoneOffset: Yup.number('Time Zone Offset must be integer').typeError(
    'Time Zone Offset must be integer',
  ),
  TrendChartDefaultPeriodHours: Yup.number(
    'Trend Chart Default Period (hrs) must be integer',
  ).typeError('Trend Chart Default Period (hrs) must be integer'),
});
